<template>
  <div>
    <div class="search-all-box">
      <a-form-model layout="inline" ref="ruleForm" :model="form">
        <a-form-model-item prop="complete_type" :wrapperCol="{span: 3}">
          <a-select v-model="form.complete_type" placeholder="请选择提交形式" style="width: 10vw" class="multiple-select" dropdownClassName="multipleDrop">
            <a-select-option value="">提交形式</a-select-option>
            <a-select-option v-for="(item, index) in workArr" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="user_name">
          <a-input v-model="form.user_name" class="search-input" style="width: 10vw" placeholder="请输入提交人姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="name">
          <a-input v-model="form.name" class="search-input" style="width: 10vw" placeholder="请输入文物名称或人物姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="venue_name">
          <a-input v-model="form.venue_name" class="search-input" style="width: 10vw" placeholder="请输入场馆名称"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="approve_status">
          <a-select v-model="form.approve_status" placeholder="评阅等级" style="width: 6vw" class="multiple-select" dropdownClassName="multipleDrop">
            <a-select-option value="">评阅等级</a-select-option>
            <a-select-option v-for="(item, index) in approveStatusList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="status">
          <a-select v-model="form.status" placeholder="状态" style="width: 6vw" class="multiple-select" dropdownClassName="multipleDrop">
            <a-select-option value="">状态</a-select-option>
            <a-select-option v-for="(item, index) in statusList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button class="search-btn" type="primary" @click="onSearch()">搜索</a-button>
          <a-button class="reset-btn" @click="resetForm()">重置</a-button>
        </a-form-model-item>
      </a-form-model>
      <div class="right-option-box">

        <template v-if="showTableSelection">
          <a-button class="option-btn" type="primary" @click="cancelSelection()">取消批量{{allState == 1? '隐藏' : '公开'}}</a-button>
          <a-button class="option-btn" type="primary" @click="showMoreDailog()">确认批量{{allState == 1? '隐藏' : '公开'}}</a-button>
        </template>
        <template v-else>
          <a-button class="option-btn" type="primary" @click="manySelection(1)">批量隐藏</a-button>
          <a-button class="option-btn" type="primary" @click="manySelection(2)">批量公开</a-button>
        </template>

        <a-button class="option-btn" type="primary" @click="exportAttach()">导出附件</a-button>
      </div>
    </div>
    <div class="table-all-box">
      <a-table :row-selection="rowSelection" :columns="columns" :data-source="tableData" rowKey="id" :bordered="false" size="small" :pagination="false">
        <!-- <template slot="status_name" slot-scope="status_name">
          {{status_name}}
        </template> -->
        <template slot="created_name" slot-scope="created_name,item">
          {{item.complete_type == 1 ?  created_name : item.created_names.join(",")}}
        </template>

        <template slot="action" slot-scope="text, scope">
          <a-button type="link" @click="toResRewview(scope)">评阅</a-button>
          <a-button type="link" @click="setShow(scope)" v-if="scope.status_name == '隐藏'">设为公开</a-button>
          <a-button type="link" @click="setHide(scope)" v-if="scope.status_name == '公开'">设为隐藏</a-button>

        </template>
      </a-table>
      <CommonModal v-model="isShowModal" title="设为公开" confirmText="确定" @confirm="handleShowConfirm">
        <div class="delete-modal">
          确认公开吗？公开后将对全部用户可见。
        </div>
      </CommonModal>
      <CommonModal v-model="isHideModal" title="设为隐藏" confirmText="确定" @confirm="handleHideConfirm">
        <div class="delete-modal">
          确认隐藏吗？
        </div>
      </CommonModal>
      <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />
    </div>
  </div>
</template>

<script>
import CommonModal from "../../../../components/CommonModal"
import { mapActions } from "vuex";
// import services from '../../../../assets/js/services';
export default {
  name: 'hsjrSubmited',
  components: {
    CommonModal
  },
  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      btnTxt: '< 返回实践班级',
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      isShowModal: false,
      isHideModal: false,
      form: {
        complete_type: "", //完成形式
        name: "", //故事名字
        user_name: "", //提交人
        venue_name: "", //基地名称
        approve_status: '',  //评分
        status: '', //是否隐藏
      },
      workArr: [
        { id: 1, name: '个人完成' },
        { id: 2, name: '小组完成' },
      ],
      approveStatusList: [
        { id: 2, name: '优秀' },
        { id: 3, name: '中等' },
        { id: 4, name: '良好' },
        { id: 5, name: '较差' },
      ],
      statusList: [
        { id: 1, name: '隐藏' },
        { id: 2, name: '显示' },
      ],
      showTableSelection: false, // 多选框是否显示
      selectedRowKeys: [], // 选中行key
      columns: [
        {
          title: "提交形式",
          dataIndex: "complete_type_name",
        },
        {
          title: "提交人",
          dataIndex: "created_name",
          scopedSlots: { customRender: 'created_name' },
        },
        {
          title: "文物名称或人物姓名",
          dataIndex: "name",
        },
        {
          title: "关联场馆",
          dataIndex: "venue_name",
          // scopedSlots: { customRender: 'source_type' },
        },
        {
          title: "评阅等级",
          dataIndex: "approve_status_name",
        },
        {
          title: "状态",
          dataIndex: "status_name",
          scopedSlots: { customRender: 'status_name' },
        },
        {
          title: "提交时间",
          dataIndex: "created_at",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ], // 从学生库选择的行key
      showDeleteModal: false,
      showChooseModal: false,
      class_id: '', //当前班级id
      studentId: '', // 单选删除时选中的学生id
      allState: "",
      selectItme: {},
      // rowSelection: null,
    };
  },

  computed: {
    rowSelection() {
      let that = this
      const { selectedRowKeys, showTableSelection } = that;
      const currentAllState = this.allState;
      return showTableSelection ? {
        selectedRowKeys,
        onChange: that.onSelectChange,
        getCheckboxProps: record => ({
          props: {
            disabled: record.status == currentAllState, // Column configuration not to be checked
          },
        }),
      } : null
    }
  },
  mounted() {
    this.class_id = this.$route.query.cid
    this.getTableList()
  },
  methods: {
    ...mapActions(["gethsjrClassReview", "setStoryStatus", "getsjrClassReviewExportAttach"]),
    getTableList() {
      let params = {
        page: this.page,
        size: this.size,
        class_id: this.class_id,
        name: this.form.name,
        user_name: this.form.user_name,
        venue_name: this.form.venue_name,
        complete_type: this.form.complete_type,
        status: this.form.status,
        approve_status: this.form.approve_status,
      };
      this.gethsjrClassReview(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    onSearch() {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange(val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.onSearch()
    },
    handleModalVisible(key, val, item) {
      this[key] = val
      this.selectItme = item
    },

    onSelectChange(rows) {
      this.selectedRowKeys = rows
    },

    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.status == this.allState
        },
      };
    },
    // 批量公开隐藏 按钮点击事件
    manySelection(type) {
      this.tableData = this.tableData.map(item => {
        return {
          ...item,
          type: type
        }
      })
      this.allState = type
      this.showTableSelection = true
    },
    // 取消公开隐藏
    cancelSelection() {
      this.allState = ""
      this.showTableSelection = false
      this.selectedRowKeys = []
    },
    // 导出实践附件
    exportAttach() {
      let that = this
      let params = {
        class_id: this.class_id,
        name: this.form.name,
        user_name: this.form.user_name,
        venue_name: this.form.venue_name,
        complete_type: this.form.complete_type,
        status: this.form.status,
        approve_status: this.form.approve_status,
      };
      that.getsjrClassReviewExportAttach(params).then((res) => {
        if (res.code == "0000" && res.data) {
          if (res.data.unique) {
            const targetRoute = this.$router.resolve({
              path: `/${that.school_code}/school/hsjr/download`,
              query: {
                cid: that.class_id,
                unique: res.data.unique,
              }
            });
            window.open(targetRoute.href, '_blank');
          }
        } else {
          that.$message.error(res.msg)
        }
      });
    },
    showMoreDailog() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.info(`请选择需要${this.allState == 1 ? '隐藏' : '公开'}的数据`)
        return
      }
      if (this.allState == 1) {
        this.handleModalVisible("isHideModal", true, {})
      }
      if (this.allState == 2) {
        this.handleModalVisible("isShowModal", true, {})
      }
    },
    async setMoreState() {
      let story_ids = this.selectedRowKeys.join(",")
      const formData = new FormData();
      formData.append("class_id", this.class_id);
      formData.append("story_ids", `${story_ids}`);
      formData.append("approve_status", this.allState);
      formData.append("_method", "put");
      let res = await this.setStoryStatus(formData)
      if (res.code == "0000") {
        this.$message.success(`${this.allState == 1 ? '批量隐藏' : "批量公开"}成功`);
        this.cancelSelection()
        this.getTableList()
        return true
      }
    },
    async setStatus(item, type) {

      const formData = new FormData();
      formData.append("class_id", this.class_id);
      formData.append("story_ids", `${item.id}`);
      formData.append("approve_status", type);
      formData.append("_method", "put");
      let res = await this.setStoryStatus(formData)
      if (res.code == "0000") {
        this.$message.success(`${type == 1 ? '隐藏' : "公开"}成功`);
        this.getTableList()
        return true
      }
    },


    setShow(scope) {
      this.handleModalVisible("isShowModal", true, scope)
    },
    handleShowConfirm() {
      if (this.allState) {
        this.setMoreState().then(res => {
          if (res) {
            this.handleModalVisible("isShowModal", false, {})
          }
        })
      } else {
        this.setStatus(this.selectItme, "2").then(res => {
          if (res) {
            this.handleModalVisible("isShowModal", false, {})
          }
        })
      }

    },
    setHide(scope) {
      this.handleModalVisible("isHideModal", true, scope)
    },
    handleHideConfirm() {
      if (this.allState) {
        this.setMoreState().then(res => {
          if (res) {
            this.handleModalVisible("isHideModal", false, {})
          }
        })
      } else {
        this.setStatus(this.selectItme, "1").then(res => {
          if (res) {
            this.handleModalVisible("isHideModal", false, {})
          }
        })
      }

    },
    toResRewview(item) {
      this.$router.push(`/${this.school_code}/school/hsjr/resReview?id=${item.id}&cid=${this.class_id}`)
    },

  },
};
</script>

<style lang="less" scoped>
.back-class-btn {
  padding: 0 16px;
  height: 32px;
  background: #b84b3c;
  border-radius: 16px;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 15px;
  line-height: 32px;
  &:hover {
    background: #a82822;
  }
}
.delete-modal {
  font-weight: bold;
  font-size: 16px;
  color: #373536;
  text-align: center;
}
.choose-modal {
  padding-top: 20px;
}
@media screen and (max-width: 1700px) {
  .search-all-box {
    flex-wrap: wrap;
    justify-content: unset;
  }
  .right-option-box {
    width: 100%;
    margin-top: 15px;
  }
}
</style>